export const EVENTS = {
    PC_SCREEN_LANDING:
    {
        name: "PC_SCREEN_LANDING",
        schema: "iglu:com.medibuddy/PC_SCREEN_LANDING/jsonschema/2-0-0",
    },
    PC_LS_ACTION:
    {
        name: "PC_LS_ACTION",
        schema: "iglu:com.medibuddy/PC_LS_ACTION/jsonschema/2-0-0",
    },
    APP_VERSION: 'v1.0',
    TAB_NAME_UPCOMING_APPOINTMENTS: 'UPCOMING_APPOINTMENTS',
    TAB_NAME_CANCELLED_APPOINTMENTS: 'CANCELLED_APPOINTMENTS',
    TAB_NAME_COMPLETED_APPOINTMENTS: 'COMPLETED_APPOINTMENTS',
    TAB_NAME_CONFIRMED_APPOINTMENTS: 'CONFIRMED_APPOINTMENTS',
    TAB_NAME_ALL_APPOINTMENTS: 'ALL_APPOINTMENTS',
    TAB_NAME_DOCUMENT_UPLOAD: 'DOCUMENT_UPLOAD',
    SERVICE_TYPE_OMS: 'OMS',
    SERVICE_NAME_LABS: "LABS",
    SERVICE_NAME_OFFLINE_CONSULTS: "OFFLINE_CONSULTS",
    ACTION: {
        RESCHEDULE_CLICKED: "RESCHEDULE_CLICKED",
        CONFIRM_CLICKED: "CONFIRM_CLICKED",
        ATTENDED_CLICKED: "ATTENDED_CLICKED",
        NOT_ATTENDED_CLICKED: "NOT_ATTENDED_CLICKED",
        REJECT_CLICKED: "REJECT_CLICKED",
        DOCUMENT_UPLOAD_CLICKED: "DOCUMENT_UPLOAD_CLICKED",
    },
    TAB_NAME: {
        ADD_DOCTOR: "ADD_DOCTOR_PAGE",
        ADD_SCHEDULE: "ADD_SCHEDULE",
        ADD_HOLIDAYS: "ADD_HOLIDAYS",
        ADD_SPOC: "ADD_SPOC",
    }
}